export default [
    {
        field: 'agreed_compensation_days',
        type: 'text',
        value: '0',
        vuetifyProps: {
            label: 'Días de compensación',
        },
        rules:['required','numeric']
    },
]